export default __webpack_public_path__ + "static/media/emanuel.0237aadf.jpeg";